import {
  CART_ADD,
  CART_ITEM_REMOVE,
  CART_QUANTITY_CHANGE,
  CART_ITEM_UNDO_REMOVE,
  SEND_ORDER,
  CART_PREPARING,
  REGISTER_USER,
  UPDATE_PROFILE,
  UPDATE_PROFILE_PASSWORD,
  SEND_RECOVERY_LINK,
  REPEAT_CART,
  FEEDBACK
} from './mutations'

import {
  GET_PAYMENTS_INFO,
  CHECK_USER_RECOVERY_TOKEN,
  GET_PAGE,
  GET_CATALOG_PRODUCTS,
  GET_PRODUCTS_GOODS,
  GET_CART_ITEMS,
  GET_ORDER_TOTAL,
  GET_SETTINGS,
  GET_TRACKER_SETTINGS,
  GET_DELIVERIES_INFO,
  USER_INFO,
  PRODUCT_INFO,
  GET_MENU,
  GET_META,
  GET_PRODUCT_GROUPS,
  GET_FOOTER_MENU,
  GET_ORDERS,
  GET_ORDER_HISTORY,
  GET_BREADCRUMBS,
  GET_CATALOG_FILTERS,
  GET_PRODUCT_BREADCRUMBS,
  GET_PAGE_BY_KEY,
  GET_PRODUCTS_SEARCH_HINT,
  GET_LOYALTY_ACCOUNT,
  GET_LOYALTY_ACCOUNT_AMOUNT,
} from './queries'

export {
  GET_PAYMENTS_INFO,
  CHECK_USER_RECOVERY_TOKEN,
  GET_PAGE_BY_KEY,
  SEND_RECOVERY_LINK,
  GET_PAGE,
  GET_PRODUCT_BREADCRUMBS,
  GET_CATALOG_FILTERS,
  GET_BREADCRUMBS,
  UPDATE_PROFILE_PASSWORD,
  UPDATE_PROFILE,
  REGISTER_USER,
  GET_ORDER_HISTORY,
  GET_ORDERS,
  GET_META,
  GET_MENU,
  CART_PREPARING,
  PRODUCT_INFO,
  USER_INFO,
  GET_CATALOG_PRODUCTS,
  GET_PRODUCTS_GOODS,
  GET_CART_ITEMS,
  GET_ORDER_TOTAL,
  GET_SETTINGS,
  GET_TRACKER_SETTINGS,
  GET_DELIVERIES_INFO,
  CART_ADD,
  CART_ITEM_REMOVE,
  CART_QUANTITY_CHANGE,
  SEND_ORDER,
  CART_ITEM_UNDO_REMOVE,
  GET_PRODUCT_GROUPS,
  GET_FOOTER_MENU,
  REPEAT_CART,
  FEEDBACK,
  GET_PRODUCTS_SEARCH_HINT,
  GET_LOYALTY_ACCOUNT,
  GET_LOYALTY_ACCOUNT_AMOUNT,
}
